<template>
  <div v-if="device.isMobile" class="navigation overflow-hidden bg-white">
    <b-nav
      class="navigation-container align-items-center overflow-auto scroll-bar"
      justified
    >
      <b-nav-item
        v-for="tab of tabs"
        :key="tab.key"
        class="cursor-pointer position-relative text-12"
        :class="{active: isActive(tab)}"
        @click="tabEvent(tab)"
      >
        <i :class="tab.icon" class="text-24"></i>
        <span class="title">{{ tab.title }}</span>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  data() {
    return {
      active: 'home',
      tabs: [
        {
          key: 'home',
          icon: 'icon-Home',
          title: this.$t('首頁'),
          event: 'home-page',
        },
        {
          key: 'exam-list-index',
          icon: 'icon-Certificate',
          title: this.$t('報名檢定'),
          event: 'exam-list-index',
        },
        {
          key: 'tournament-list-index',
          icon: 'icon-Certificate',
          title: this.$t('報名比賽'),
          event: 'tournament-list-index',
        },
        {
          key: 'personal',
          icon: 'icon-Member',
          title: this.$t('個人'),
          event: 'personal',
        },
      ],
    };
  },
  computed: {
    device() {
      return this.$store.getters['env/device'];
    },
    isLogin() {
      return this.$store.state.auth.isLogin;
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$route?.name) {
          if (this.$route.matched[1]) {
            this.active = this.$route.matched[1].name;
          } else {
            this.active = this.$route.matched[0].name;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    tabEvent(tab) {
      if (this.$route.name !== tab.event) {
        if (tab.event === 'personal') {
          if (!this.isLogin) {
            return this.$store.commit('env/setLoginModalShow', true);
          }
          return this.$router.push({
            name: 'personal-index',
          });
        }
        return this.$router.push({name: tab.event});
      }
    },
    isActive(tab) {
      return this.active.includes(tab.event);
    },
    iconClass(tab) {
      return `icon-${tab.icon}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.navigation {
  .logo-container {
    padding: 20px 22px 19px;
    margin: 0 0 8px;
  }
  .navigation-container {
    box-shadow: inset 0 1px 0 0 #dcdfe6;
    min-height: 62px;
  }
  .nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    min-height: 62px;
    color: $gray-500;
    border-radius: 10px;
  }
  .nav-item {
    &.active .nav-link {
      color: $secondary;
    }
  }
  .title {
    line-height: 20px;
    margin-top: 3px;
  }

  .notification {
    width: 14px;
    height: 14px;
    top: 10px;
    right: 9px;
    border-radius: 50%;
  }
}
</style>
